"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  enableAccessLogs: true,
  getLogLevel: true
};
Object.defineProperty(exports, "getLogLevel", {
  enumerable: true,
  get: function get() {
    return _utils.getLogLevel;
  }
});
exports.enableAccessLogs = void 0;

var _global = require("./global");

var _logger = require("./logger");

Object.keys(_logger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logger[key];
    }
  });
});

var _error = require("./error");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _utils = require("./utils");

var noop = function noop() {};

var enableAccessLogs = typeof window === 'undefined' ? function (app) {
  return require('./access')["default"](app, (0, _global.getGlobalObject)().logger);
} : noop;
exports.enableAccessLogs = enableAccessLogs;